import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  InstructionIntroItem,
  InstructionSection,
  PaletteLegendItem,
  QuestionPaperItem,
  QuestionPaperPopupMode,
} from '../../model/test-series.model';
import { ImageEnum } from '../../../../shared/utils/image.enum';
import { RichHtmlPipe } from '../../../../shared/pipes/rich-html.pipe';

@Component({
  selector: 'app-question-paper-popup',
  imports: [RichHtmlPipe],
  templateUrl: './question-paper-popup.html',
  styleUrl: './question-paper-popup.css',
})
export class QuestionPaperPopupComponent {
  @Input() isOpen = false;
  @Input() mode: QuestionPaperPopupMode | null = null;
  @Input() activePartLabel = '';
  @Input() popupHeading = '';
  @Input() questions: QuestionPaperItem[] = [];
  @Input() instructionIntroItems: InstructionIntroItem[] = [];
  @Input() instructionSections: InstructionSection[] = [];
  @Input() paletteLegend: PaletteLegendItem[] = [];

  @Output() close = new EventEmitter<void>();

  protected readonly imageEnum = ImageEnum;

  protected get title(): string {
    return this.mode === 'question-paper' ? 'Question Paper' : 'Instructions';
  }

  protected get questionGroups(): Array<{
    label: string;
    questions: Array<QuestionPaperItem & { displayNumber: number }>;
  }> {
    const groupSize = 5;
    const groups: Array<{
      label: string;
      questions: Array<QuestionPaperItem & { displayNumber: number }>;
    }> = [];

    for (let index = 0; index < this.questions.length; index += groupSize) {
      const start = index + 1;
      const end = Math.min(index + groupSize, this.questions.length);

      groups.push({
        label: `Questions ${start}-${end}`,
        questions: this.questions.slice(index, index + groupSize).map((question, offset) => ({
          ...question,
          displayNumber: index + offset + 1,
        })),
      });
    }

    return groups;
  }

  protected onClose(): void {
    this.close.emit();
  }

  protected getSectionStart(sectionId: InstructionSection['id']): number | null {
    if (sectionId === 'parts') {
      return 4;
    }

    if (sectionId === 'navigation') {
      return 10;
    }

    if (sectionId === 'answering') {
      return 12;
    }

    return null;
  }
}
